module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-fraternity-19c78c5bdf499d3e151d22130f70f477.jpg";